import { useEffect, useState } from "react";
import GButton from "../../components/ui/base/GButton";
import useMainStore from "../../store/mainState";
import GCheckbox from "../../components/ui/base/GCheckbox";
import BudgetCalculator from "../../components/budgetCalculator";
import { useTranslation } from "react-i18next";

const ResponsibleGamblingContent = ({ activeSubItem, isChecked, setIsChecked }: { activeSubItem: string; isChecked: boolean; setIsChecked: (v: boolean) => void }) => {
    const { t } = useTranslation();
    if (activeSubItem === 'faq') return (
        <div className="bg-[#111a30] p-[30px] rounded-[25px] mt-[30px] ">
            <div className="max-w-[1300px]">
                <h1 className="text-[30px] font-bold text-white mb-[25px]">{t('responsibleGambling.faqTitle')}</h1>
                <p className="text-[20px]  text-[#A2A2A2]">{t('responsibleGambling.faqIntro')}</p>
                <ul className="list-disc list-inside">
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.faqTip1')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.faqTip2')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.faqTip3')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.faqTip4')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.faqTip5')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.faqTip6')}</li>
                </ul>
                <p className="text-[20px]  text-[#A2A2A2]">{t('responsibleGambling.faqQuestionIntro')}</p>
                <ul className="list-disc list-inside">
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.faqQ1')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.faqQ2')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.faqQ3')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.faqQ4')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.faqQ5')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.faqQ6')}</li>
                </ul>
                <h1 className="text-[20px] font-bold text-white mb-[5px] mt-[25px]">{t('responsibleGambling.whatToDo')}</h1>
                <p className="text-[20px]  text-[#A2A2A2]">{t('responsibleGambling.whatToDoText')}</p>
                <ul className="list-disc list-inside">
                    <li className="text-[20px] text-[#A2A2A2]">Gamblers Anonymous</li>
                    <li className="text-[20px] text-[#A2A2A2]">Gambling Therapy</li>
                    <li className="text-[20px] text-[#A2A2A2]">GamCare</li>
                </ul>
                <h1 className="text-[20px] font-bold text-white mb-[5px] mt-[25px]">{t('responsibleGambling.howWeCanHelp')}</h1>
                <p className="text-[20px]  text-[#A2A2A2]">{t('responsibleGambling.howWeCanHelpText')}</p>
                <h1 className="text-[20px] font-bold text-white mb-[5px] mt-[25px]">{t('responsibleGambling.underageGambling')}</h1>
                <p className="text-[20px]  text-[#A2A2A2]">{t('responsibleGambling.underageGamblingText')}</p>
                <ul className="list-disc list-inside">
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.underageTip1')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.underageTip2')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.underageTip3')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.underageTip4')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.underageTip5')}</li>
                </ul>
            </div>
        </div>
    );
    if (activeSubItem === 'self-assessment') return (
        <div className="bg-[#111a30] p-[30px] rounded-[25px] mt-[30px]">
            <div className="max-w-[1300px]">
                <h1 className="text-[30px] font-bold text-white mb-[25px]">{t('responsibleGambling.selfAssessmentTitle')}</h1>
                <p className="text-[20px]  text-[#A2A2A2]">{t('responsibleGambling.selfAssessmentIntro')}</p>
                <h1 className="text-[20px] font-bold text-white mb-[5px] mt-[25px]">{t('responsibleGambling.selfAssessmentQuestion')}</h1>
                <ul className="list-decimal list-outside ml-6">
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.saQ1')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.saQ2')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.saQ3')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.saQ4')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.saQ5')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.saQ6')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.saQ7')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.saQ8')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.saQ9')}</li>
                    <li className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.saQ10')}</li>
                </ul>
                <p className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.saReminder')}</p>
            </div>
        </div>
    );
    if (activeSubItem === 'gambling-limits') return (
        <div className="bg-[#111a30] p-[30px] rounded-[25px] mt-[30px]">
            <div className="max-w-[1300px]">
                <h1 className="text-[20px] font-bold text-white mb-[25px]">{t('responsibleGambling.gamblingLimitsTitle')}</h1>
                <p className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.gamblingLimitsText1')}</p>
                <p className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.gamblingLimitsText2')}</p>
                <p className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.gamblingLimitsText3')}</p>
            </div>
            <GButton variant="primary" className="w-[100%] p-[20px] mt-[40px]">{t('responsibleGambling.setLimits')}</GButton>
            <div className="w-[500px] bg-[#262525] rounded-[25px] py-[60px] px-[50px] text-center flex flex-col items-center gap-[20px] mt-[50px] ml-[calc(100%-500px)]">
                <img className="w-[170px] h-[170px]" src={require("../../assets/images/chat.png")} alt="" />
                <h1 className="text-[20px] font-bold text-white">{t('responsibleGambling.needHelp')}</h1>
                <p className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.needHelpText')}</p>
                <GButton variant="primary" className="w-[calc(100%-100px)] mx-[50px] p-[20px] mt-[40px]">{t('responsibleGambling.chatWithUs')}</GButton>
            </div>
        </div>
    );
    if (activeSubItem === 'self-exclusion') return (
        <div className="bg-[#111a30] p-[30px] rounded-[25px] mt-[30px]">
            <div className="max-w-[1300px]">
                <h1 className="text-[20px] font-bold text-white mb-[25px]">{t('responsibleGambling.selfExclusionTitle')}</h1>
                <p className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.selfExclusionText')}</p>
                <p className="text-[20px] text-[#A2A2A2] my-[40px]">{t('responsibleGambling.selfExclusionEmail')}</p>
                <h1 className="text-[20px] font-bold text-white">{t('responsibleGambling.step1Title')}</h1>
                <p className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.step1Text')}</p>
                <h1 className="text-[20px] font-bold text-white mt-[20px]">{t('responsibleGambling.step2Title')}</h1>
                <p className="text-[20px] text-[#A2A2A2]">{t('responsibleGambling.step2Text')}</p>
            </div>
        </div>
    );
    if (activeSubItem === 'budget-calculator') return <BudgetCalculator />;
    return null;
};

const ResponsibleGambling = () => {
    const { t } = useTranslation();
    const { isCollapsed, user, activeItem, setActiveItem, activeSubItem, setActiveSubItem } = useMainStore();
    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
        if (!activeSubItem || (
            activeSubItem !== 'faq' &&
            activeSubItem !== 'self-assessment' &&
            activeSubItem !== 'gambling-limits' &&
            activeSubItem !== 'self-exclusion' &&
            activeSubItem !== 'budget-calculator'
        )) {
            setActiveSubItem('faq');
        }
    }, []);
    return (
        <div>
            <h1 className="text-[30px] font-bold text-white mb-[15px]">{t('responsibleGambling.title')}</h1>
            <div className="flex gap-[20px] overflow-x-auto scrollbar-hide pb-[2px]">
                <button onClick={() => setActiveSubItem('faq')} className={`text-[20px] font-bold whitespace-nowrap flex-shrink-0 px-[25px] py-[10px] rounded-[25px] ${activeSubItem === 'faq' ? 'bg-gradient-to-r from-[#0086D3] to-[#4DBDFF] text-[#fff]' : 'bg-[#3A4142] text-[#B3BEC1]'}`}>{t('responsibleGambling.faq')}</button>
                <button onClick={() => setActiveSubItem('self-assessment')} className={`text-[20px] font-bold whitespace-nowrap flex-shrink-0 px-[25px] py-[10px] rounded-[25px] ${activeSubItem === 'self-assessment' ? 'bg-gradient-to-r from-[#0086D3] to-[#4DBDFF] text-[#fff]' : 'bg-[#3A4142] text-[#B3BEC1]'}`}>{t('responsibleGambling.selfAssessment')}</button>
                <button onClick={() => setActiveSubItem('gambling-limits')} className={`text-[20px] font-bold whitespace-nowrap flex-shrink-0 px-[25px] py-[10px] rounded-[25px] ${activeSubItem === 'gambling-limits' ? 'bg-gradient-to-r from-[#0086D3] to-[#4DBDFF] text-[#fff]' : 'bg-[#3A4142] text-[#B3BEC1]'}`}>{t('responsibleGambling.gamblingLimits')}</button>
                <button onClick={() => setActiveSubItem('self-exclusion')} className={`text-[20px] font-bold whitespace-nowrap flex-shrink-0 px-[25px] py-[10px] rounded-[25px] ${activeSubItem === 'self-exclusion' ? 'bg-gradient-to-r from-[#0086D3] to-[#4DBDFF] text-[#fff]' : 'bg-[#3A4142] text-[#B3BEC1]'}`}>{t('responsibleGambling.selfExclusion')}</button>
                <button onClick={() => setActiveSubItem('budget-calculator')} className={`text-[20px] font-bold whitespace-nowrap flex-shrink-0 px-[25px] py-[10px] rounded-[25px] ${activeSubItem === 'budget-calculator' ? 'bg-gradient-to-r from-[#0086D3] to-[#4DBDFF] text-[#fff]' : 'bg-[#3A4142] text-[#B3BEC1]'}`}>{t('responsibleGambling.budgetCalculator')}</button>
            </div>

            <ResponsibleGamblingContent activeSubItem={activeSubItem || ''} isChecked={isChecked} setIsChecked={setIsChecked} />
        </div>
    )
}

export default ResponsibleGambling
